var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e(),(_vm.$route.meta.showTab)?_c('tabbar-new-new'):_vm._e(),_c('loading'),_c('skeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }